export default "__VITE_ASSET__3f254341__"